var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNorthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C11.1506 0 6.8054 2.15775 3.87122 5.56519H28.1288C25.1947 2.15775 20.8495 0 16 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1288 26.4348H3.87122C6.8054 29.8423 11.1506 32 16 32C20.8495 32 25.1947 29.8423 28.1288 26.4348Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6516 7.6521H2.34838C0.859063 10.0824 0 12.9407 0 15.9999C0 19.0591 0.859063 21.9175 2.34838 24.3477H29.6516C31.1409 21.9175 32 19.0591 32 15.9999C32 12.9407 31.1409 10.0824 29.6516 7.6521Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84302 22.1565C13.2432 22.1565 15.9995 19.4001 15.9995 16C15.9995 12.5999 13.2432 9.84351 9.84302 9.84351C6.44288 9.84351 3.68652 12.5999 3.68652 16C3.68652 19.4001 6.44288 22.1565 9.84302 22.1565Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84347 9.84351L11.2248 14.0948H15.7022L12.0786 16.7224L13.4707 20.9864L9.84347 18.3463L6.22172 20.9815L7.60835 16.7224L3.98804 14.0948H8.4621L9.84347 9.84351Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNorthKorea);
export default __webpack_public_path__ + "static/media/flag_north_korea.ca89377c3cd36606624c35c25a12301d.svg";
export { ForwardRef as ReactComponent };